import React from 'preact/compat';
import { useField } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';

export type RecaptchaResponse = string | null;

declare global {
    interface Window {
        recaptchaSiteKey: string,
    }
}

export default function RecaptchaField({ name }: RecaptchaFieldProps) {
    const [,, { setValue }] = useField<RecaptchaResponse>(name);

    function handleChange(response: RecaptchaResponse) {
        setValue(response);
    }

    return (
        <ReCAPTCHA
            sitekey={window.recaptchaSiteKey}
            onChange={handleChange}
        />
    );
}

type RecaptchaFieldProps = {
    name: string,
};
